import { Material } from '@core/model/Material.model';
import { ProdWarning } from './prodWarning.model';
import { DimensionModel } from '@core/model/dimension.model';
import { PVBInfo } from './PVBInfo.model';
import { LuzCapaInfo } from './LuzCapaInfo.model';
import { ModelInfo } from './modelInfo.model';
import { GlassInfo } from './GlassInfo.model';
import { ConfigService } from '@core/model/configService.model';
import { GlassService } from '@core/model/glassService.model';

export class VilaxInfo extends ModelInfo {
    vAncho2: number;
    vAlto2: number;
    vDescuadrado: boolean;
    vCorteRapido: boolean;
    vPlantilla: boolean;
    vListaConfig: DimensionModel[];
    vListaLuzCapa: LuzCapaInfo[];
    vListaPVB: PVBInfo[];
    vListaMateriales: Material[];
    vListaRestricciones: ProdWarning[];
    vConfiguracion: string;
    vTemplado: boolean;
    vPulido: boolean;
    vCanteado: boolean;
    vFiloMatado: boolean;
    vArenado: boolean;
    vListaServicios: ConfigService[];
    GlassServices: GlassService[];
    vCornerTL: string;
    vCornerTR: string;
    vCornerBL: string;
    vCornerBR: string;
    vSideTop: string;
    vSideLeft: string;
    vSideRight: string;
    vSideBottom: string;
    vEspesor: string;
    vLaminadoPerimetral: boolean;

    constructor() {
    super();
    this.vModelo = 'VILAX';
    this.vCodArticulo = '0603201';
    this.vCantidad = 1;
    this.vDescuadrado =  false;
    this.vCorteRapido = false;
    this.vPlantilla = false;
    this.vAlto2 = 0;
    this.vAncho2 = 0;
    this.vListaConfig = [];
    this.vListaLuzCapa = [];
    this.vListaPVB = [];
    this.vListaMateriales = [];
    this.vListaRestricciones = [];
    this.vConfiguracion = '';
    this.vTemplado = false;
    this.vPulido = false;
    this.vCanteado = false;
    this.vFiloMatado = false;
    this.vArenado = false;
    this.vListaServicios = [];
    this.GlassServices = [];
    this.vCornerTL = '';
    this.vCornerTR = '';
    this.vCornerBL = '';
    this.vCornerBR = '';
    this.vSideTop = '';
    this.vSideLeft = '';
    this.vSideRight = '';
    this.vSideBottom = '';
    this.vEspesor = '';
    this.vLaminadoPerimetral = false;
    }

    redimensionarModelo() {
        let ModeloTmp: GlassInfo;
        if (this.vListaLuzCapa.length > 0) {
            this.vListaLuzCapa.forEach(CapaTmp => {
                CapaTmp.vAncho1 = this.vAncho1;
                CapaTmp.vAlto1 = this.vAlto1;
                CapaTmp.vAncho2 = this.vAncho2;
                CapaTmp.vAlto2 = this.vAlto2;
                ModeloTmp = CapaTmp.vModelo as GlassInfo;
                if (ModeloTmp !== undefined) {
                    let vGlassInfo = new GlassInfo();
                    vGlassInfo.vAncho1 = this.vAncho1;
                    vGlassInfo.vAlto1 = this.vAlto1;
                    vGlassInfo.vDescuadrado = this.vDescuadrado;
                    vGlassInfo.vAncho2 = this.vAncho2;
                    vGlassInfo.vAlto2 = this.vAlto2;
                    ModeloTmp.vAncho1 = this.vAncho1;
                    ModeloTmp.vAlto1 = this.vAlto1;
                    ModeloTmp.vDescuadrado = this.vDescuadrado;
                    ModeloTmp.vAncho2 = this.vAncho2;
                    ModeloTmp.vAlto2 = this.vAlto2;
                    vGlassInfo.vListaServicios = ModeloTmp.vListaServicios;
                    vGlassInfo.redimensionarModelo();
                    ModeloTmp.vListaServicios = vGlassInfo.vListaServicios;
                }
            });
        }
    }

    getEspesor() {
        let glassTmp: GlassInfo;
        let espesor = '';
        const CantCapas = this.vListaLuzCapa.length;
        let i = 0;

        if (CantCapas > 0) {
            this.vListaLuzCapa.forEach(Capa => {
                i++;
                if (Capa.vModelo !== undefined) {
                    glassTmp = Capa.vModelo as GlassInfo;
                    espesor += (+glassTmp.vEspesorVidrio).toString();
                }
            });
            this.vListaPVB.forEach(Capa => {
                i++;
                if (Capa.vIdentificador === 1) {
                    espesor += '.';
                }

                if (Capa !== undefined) {
                    switch (Capa.vEspesor) {
                        case 0.38: {
                            espesor += '1';
                            break;
                        }
                        case 0.76: {
                            espesor += '2';
                            break;
                        }
                        case 1.14: {
                            espesor += '3';
                            break;
                        }
                        case 1.52: {
                            espesor += '4';
                            break;
                        }
                    }
                }
            });
        }

        if (i === (CantCapas * 2) - 1) {
            return espesor;
        } else {
            return '';
        }
    }
}
